// eslint-disable-next-line jsx-a11y/href-no-hash
import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import PageLayout from './components/PageLayout'
import PageMobileNav from './components/PageMobileNav'
import FourOhFour from './pages/FourOhFour'
import MainNav from './components/MainNav'
import { Sidebar, Segment, Menu } from 'semantic-ui-react'
import CookieConsent, { Cookies } from "react-cookie-consent"

import config from './config'
import './app.css'

class App extends Component {
  renderRoutes = () => {
    return Object.keys(config.pages).map(page => {
      return (
        <Route
          key={config.pages[page].label}
          path={config.pages[page].path}
          component={PageLayout}
        />
      )
    })
  }

  render() {
    const { pages, siteLabel, footer, siteLogoUrl } = config
    const { visible } = this.state
    return (
      <div className="app">
        <Sidebar.Pushable as={Segment}>
          <Sidebar
            as={Menu}
            animation="overlay"
            width="thin"
            visible={visible}
            icon="labeled"
            onClick={this.toggleVisibility}
            vertical
            inverted
          >
            <PageMobileNav subpages={pages} />
          </Sidebar>
          <Sidebar.Pusher>
            <MainNav
              subpages={pages}
              siteLabel={siteLabel}
              siteLogoUrl={siteLogoUrl}
              toggleVisibility={this.toggleVisibility}
            />
            <Switch>
              <Route path="/" exact>
              <Redirect to="/storitve" />
              </Route>
              {this.renderRoutes()}
              <Route component={FourOhFour} />
            </Switch>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
        <CookieConsent buttonText="Se strinjam">Ta spletna stran uporablja piškotke za zagotavljanje osnovne funkcionalnosti. Z nadaljno uporabo sprejemate piškotke.</CookieConsent>
      </div>
    )
  }
  state = { visible: false }
  toggleVisibility = () => this.setState({ visible: !this.state.visible })
}

export default App



// WEBPACK FOOTER //
// ./src/App.js